import { FC, ReactNode } from 'react';
import { Container, CustomButton, CustomToggleButton, FlexHeader } from './InfoContainer.styles';
import { PlusIconTwoTone } from '@room-match/shared-ui-components';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { ViewModeProps } from 'shared/hooks/PetsCars/useViewMode';
import { Box } from '@material-ui/core';
import { ToggleButtonGroup } from '@material-ui/lab';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
type InfoContainerProps = {
  title: string;
  button_text: string;
  children?: ReactNode;
  viewMode: ViewModeProps;
  onAddFormClick: VoidFunction;
  onViewClick: (value: ViewModeProps) => void;
};

const InfoContainer: FC<InfoContainerProps> = ({
  title,
  button_text = 'Add',
  children,
  viewMode,
  onAddFormClick,
  onViewClick,
}) => {
  return (
    <Container>
      <FlexHeader>
        <CustomTypography fontSize={25}>{title}</CustomTypography>
        <Box style={{ display: 'flex', gap: 10, alignItems: 'stretch' }}>
          <ToggleButtonGroup color="red !important" value={viewMode} style={{ height: 40 }}>
            <CustomToggleButton onClick={() => onViewClick('list')} value="list" aria-label="left aligned">
              <ViewListIcon />
            </CustomToggleButton>
            <CustomToggleButton onClick={() => onViewClick('grid')} value="grid" aria-label="centered">
              <ViewComfyIcon />
            </CustomToggleButton>
          </ToggleButtonGroup>
          <CustomButton startIcon={<PlusIconTwoTone />} variant="outlined" onClick={onAddFormClick}>
            {button_text}
          </CustomButton>
        </Box>
      </FlexHeader>
      {children}
    </Container>
  );
};

export default InfoContainer;
